import mermaid from 'mermaid';
import { useEffect, useRef } from 'react';

export const GitGraph = ({chart}: any) => {

    const mermaidRef = useRef(null);
    useEffect(() => {
        // If the chart definition changes, re-render the Mermaid diagram
        if (mermaidRef.current && chart) {
          try {
            mermaid.initialize({
              startOnLoad: true, // Automatically initialize Mermaid diagrams on page load
            });
            mermaid.contentLoaded(); // Forces Mermaid to reload and render the diagram
          } catch (err) {
            console.error('Error rendering Mermaid chart:', err);
          }
        }
      }, [chart]); // Dependency array ensures the effect runs when 'chart' changes
    
    return (
    <div
      ref={mermaidRef}
      className="mermaid"
      style={{ width: '100%', height: 'auto' }}
    >
      {chart}
    </div>
  );
}